'use client'

import CustomerQuote from '@/components/CustomerQuote'

const PayhawkCustomerQuote = () => (
    <CustomerQuote
        sx={{
            height: {
                xs: `792px`,
                sm: `792px`,
                md: `480px`,
                lg: `480px`,
                xl: `480px`,
            },
        }}
        light={false}
        backgroundImageSrc={'/images/payhawk-case-study/payhawk-quote-borisov-desktop.png'}
        mobileBackgroundImageSrc={'/images/payhawk-case-study/payhawk-quote-borisov-mobile.png'}
        text={
            <>
                Through speaking with our customers we learned that many wanted help understanding
                the CO₂e emissions related to their company spend. Working with Lune, we’ve brought
                that to life quickly and easily.
            </>
        }
        avatar={{
            title: 'Hristo Borisov',
            subtitle: 'Co-Founder and CEO at Payhawk',
            imageSrc: '/images/payhawk-case-study/boris.png',
        }}
    />
)

export default PayhawkCustomerQuote
